export default __webpack_public_path__ + "static/media/minun-hoitoni-lightblue.b1721d4f.svg";